// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "Inter";
	font-style: normal;
	font-weight: 400;
	font-display: swap;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}

@font-face {
	font-family: "Inter";
	font-style: normal;
	font-weight: 500;
	font-display: swap;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}

@font-face {
	font-family: "Inter";
	font-style: normal;
	font-weight: 600;
	font-display: swap;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@font-face {
	font-family: "Inter";
	font-style: normal;
	font-weight: 700;
	font-display: swap;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}
`, "",{"version":3,"sources":["webpack://./src/admin/custom.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,4DAAwD;AACzD;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,4DAAuD;AACxD;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,4DAAyD;AAC1D;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,4DAAqD;AACtD","sourcesContent":["@font-face {\r\n\tfont-family: \"Inter\";\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tfont-display: swap;\r\n\tsrc: url(\"../fonts/Inter-Regular.woff2\") format(\"woff2\");\r\n}\r\n\r\n@font-face {\r\n\tfont-family: \"Inter\";\r\n\tfont-style: normal;\r\n\tfont-weight: 500;\r\n\tfont-display: swap;\r\n\tsrc: url(\"../fonts/Inter-Medium.woff2\") format(\"woff2\");\r\n}\r\n\r\n@font-face {\r\n\tfont-family: \"Inter\";\r\n\tfont-style: normal;\r\n\tfont-weight: 600;\r\n\tfont-display: swap;\r\n\tsrc: url(\"../fonts/Inter-SemiBold.woff2\") format(\"woff2\");\r\n}\r\n\r\n@font-face {\r\n\tfont-family: \"Inter\";\r\n\tfont-style: normal;\r\n\tfont-weight: 700;\r\n\tfont-display: swap;\r\n\tsrc: url(\"../fonts/Inter-Bold.woff2\") format(\"woff2\");\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
